import axios, { AxiosInstance } from 'axios';
import { Message } from '@arco-design/web-react';
import * as Sentry from '@sentry/react';

declare module 'axios' {
  export interface AxiosRequestConfig {
    unwrap?: boolean;
  }
}

const instance: AxiosInstance = axios.create();

export const xsrfToken = localStorage.getItem('xsrftoken') || '';

instance.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      if (config.url === '/api/xsrftoken') {
        return config;
      } else {
        config.params = {
          ...config.params,
          xsrfToken: config.params?.xsrfToken || xsrfToken,
        };
      }
    }
    if (config.method === 'post') {
      /** headers 修改放在最前面，post 请求都要转 formData */
      config.headers = {
        'Content-Type': 'multipart/form-data',
        ...config.headers,
      };
      if (config.url === '/api/search/upload') {
        return config;
      } else {
        config.data = {
          ...config.data,
          xsrfToken,
        };
      }
    }
    return config;
  },
  error => {
    Sentry.addBreadcrumb({
      message: 'Axios Request Failed',
      level: 'error',
      data: {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
      },
    });
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  response => {
    const { config } = response || {};
    /** 标识请求不解构 */
    if (typeof config?.unwrap === 'boolean' && !config?.unwrap) {
      return response;
    }
    if (response.status === 200) {
      // errno 或 code 为 0 表示成功，其他都为失败
      if (response.data?.errno === 0 || response.data?.code === 0) {
        return response.data?.data;
      } else {
        // 失败抛出 reject 才能被 catch 捕获
        return Promise.reject(response.data);
      }
    } else {
      Message.error(`请求异常：${response.statusText}`);
      return response;
    }
  },
  error => {
    Sentry.addBreadcrumb({
      message: 'Axios Request Failed',
      level: 'error',
      data: {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
      },
    });
    return Promise.reject(error);
  },
);

export default instance;
